import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-4 p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = { class: "text-xl font-semibold text-gray-800" }
const _hoisted_3 = { class: "flex space-x-4" }
const _hoisted_4 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_5 = { class: "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" }
const _hoisted_6 = { class: "mb-1 font-semibold" }

import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { AxiosResponse } from 'axios';

import { useUiStore } from '@/stores';
import SpamNumberService from '@/services/api/SpamNumberService';
import { toastServiceError } from '@/services/core/notification';
import { Permission, SpamNumberModel } from '@/types';
import { applyPhoneMask } from '@/utils/number';


export default /*@__PURE__*/_defineComponent({
  __name: 'SpamNumberDetailPage',
  setup(__props) {

const route = useRoute();

const uiStore = useUiStore();

const spamNumber = ref<SpamNumberModel | undefined>(undefined);

const setLoading = (loading: boolean) => uiStore.setIsLoading(loading);

const fetchSpamNumber = async (id: number) => {
    setLoading(true);
    try {
        const response: AxiosResponse<SpamNumberModel> =
            await SpamNumberService.get<SpamNumberModel>(id);
        spamNumber.value = response.data;
    } catch (error) {
        toastServiceError(error);
    } finally {
        setLoading(false);
    }
};

onMounted(() => {
    const id = Number(route.params.id);
    if (!isNaN(id)) {
        fetchSpamNumber(id);
    }
});

return (_ctx: any,_cache: any) => {
  const _component_UiBackButton = _resolveComponent("UiBackButton")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UiPageHeader = _resolveComponent("UiPageHeader")!
  const _component_UiAuditStatusInfo = _resolveComponent("UiAuditStatusInfo")!
  const _component_UiPanel = _resolveComponent("UiPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiPageHeader, null, {
      info: _withCtx(() => [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('spamNumber.view.title')), 1)
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_UiBackButton, { fallbackTo: { name: 'ListSpamNumber' } }),
          (_ctx.$can(_unref(Permission).EDIT_SPAM_NUMBER))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: { name: 'EditSpamNumberById', params: { id: _unref(route).params.id } },
                class: "block hover:bg-gray-50"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_UiButton, {
                    variant: "primary",
                    "text-variant": "white"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Edit')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    (spamNumber.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_UiPanel, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('spamNumber.labels.number')), 1),
                  _createElementVNode("p", null, _toDisplayString(_unref(applyPhoneMask)(spamNumber.value.number)), 1)
                ])
              ]),
              _createVNode(_component_UiAuditStatusInfo, {
                "model-value": spamNumber.value,
                class: "bt-1 mt-4 border-t border-gray-300 pt-2"
              }, null, 8, ["model-value"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})